import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-component p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { for: "fileType" }
const _hoisted_4 = {
  key: 0,
  class: "p-field p-col-6"
}
const _hoisted_5 = { for: "searchValue" }
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = { class: "field-checkbox p-col-12" }
const _hoisted_8 = { for: "skipErrors" }
const _hoisted_9 = { class: "p-field p-col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_FileUpload = _resolveComponent("FileUpload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.MasterData.FileType')), 1),
      _createVNode(_component_Dropdown, {
        id: "fileType",
        modelValue: _ctx.value.fileType,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.fileType) = $event)),
        options: _ctx.fileTypes,
        filter: false,
        optionValue: "id",
        optionLabel: "description",
        showClear: false,
        onChange: _ctx.update
      }, null, 8, ["modelValue", "options", "onChange"])
    ]),
    (_ctx.value.fileType === 'csv')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('Squeeze.MasterData.CsvSeparator')) + " *", 1),
          _createVNode(_component_InputText, {
            id: "searchValue",
            modelValue: _ctx.value.csvSeparator,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.csvSeparator) = $event)),
            onChange: _ctx.update,
            maxLength: "3",
            autofocus: ""
          }, null, 8, ["modelValue", "onChange"]),
          (_ctx.v$.csvSeparator.$invalid && _ctx.showErrorMessage)
            ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.System.CsvSeparator')})), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('Squeeze.MasterData.SkipErrors')), 1),
      _cache[3] || (_cache[3] = _createTextVNode("  ", -1)),
      _createVNode(_component_Checkbox, {
        id: "skipErrors",
        modelValue: _ctx.value.skipErrors,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.skipErrors) = $event)),
        binary: true
      }, null, 8, ["modelValue"]),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_FileUpload, {
        name: "documentFile",
        customUpload: true,
        multiple: false,
        showCancelButton: true,
        uploadFiles: _ctx.files,
        cancelLabel: _ctx.$t('Squeeze.General.Clear'),
        chooseLabel: _ctx.$t('Squeeze.General.Choose'),
        customProgress: _ctx.progress,
        uploadLabel: _ctx.uploadLabel,
        customUploadDisabled: _ctx.disableUploadButton,
        fileContentHeight: '5rem',
        invalidFileSizeMessage: '{0}: ' + _ctx.$t('Squeeze.Validation.General.InvalidFileSize') + ' ' + '{1}',
        onSelect: _ctx.onSelectFiles,
        onUploader: _ctx.fileUploader,
        onClear: _ctx.clearFiles,
        onRemoveFile: _ctx.removeFile,
        accept: '.' + _ctx.value.fileType
      }, null, 8, ["uploadFiles", "cancelLabel", "chooseLabel", "customProgress", "uploadLabel", "customUploadDisabled", "invalidFileSizeMessage", "onSelect", "onUploader", "onClear", "onRemoveFile", "accept"])
    ])
  ]))
}